import { render, staticRenderFns } from "./InventoryRequestForm.vue?vue&type=template&id=c0c6225e&"
import script from "./InventoryRequestForm.vue?vue&type=script&lang=js&"
export * from "./InventoryRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports